//Used By Non=Host to submit team for consideration
export const registerTeamName = (team) =>{
    return {
        type:"ADD_TEAM_TO_ACTIVITY",
        payload:team
    };
};
//The list of teams waiting to be approved
export const updateNewTeamList = (newList) =>{
    return{
        type:"UPDATED_NEW_TEAM_LIST",
        payload:newList
    }
};
//Used by Host to approve a team
export const submitTeamForApproval = (team) => {
    return {
        type:"SUBMIT_TEAM_FOR_APPROVAL",
        payload:team
    }
};
//Remove the team from the Proposed Team List (with or without approval)
export const clearSubmitTeamForApproval = (team) => {
    return {
        type:"REMOVE_SUBMIT_TEAM_FOR_APPROVAL",
        payload:team
    }
};
//Adds the Team to the team Obj (with teaid as key. Will overwrite changes from that teamid
export const updateCurrentActivityDataTeams = (update) =>{
    return {
        type:"UPDATE_CURRENT_ACTIVITY_DATA_TEAMS",
        payload:update
    }
};

export const resetGameState = (update) => {
    return {
        type:"RESET_GAME_STATE",
        payload:update
    }
};
